<div class="overlay">
	{#if state != false}

		<div class="video" class:hidden={state.type!='video'}>
			<div class="cropper" style="background-image:url('/res/lastframes/{scenario.vars.scope}/{lastnode}.jpg');">
				<div class="video-wrap">
					<video id="html-video" src="" onclick="this.paused ? this.play() : this.pause();"></video>
				</div>
				<!-- <div id="youtube-player-element"></div> -->
			</div>
		</div>

		{#if state.type == 'buttons'}
			<div out:scale class="content" style="background-image:url('/res/lastframes/{scenario.vars.scope}/{lastnode}.jpg');">
				<Options {state} vars={scenario.vars} />
			</div>
		{/if}

		{#if state.type == 'results'}
			<div out:scale class="content" style="background-image:url('/res/lastframes/{scenario.vars.scope}/{lastnode}.jpg');">
				<Results on:click={tryAgain} {state} vars={scenario.vars} />
			</div>
		{/if}

	{/if}
	<div class="orientation-blocking">
		<img alt="Orientation warning" class="info" src="/res/orientation.svg" />
	</div>
</div>

<style type="text/scss">
@import '../sass/breakpoints';
.overlay{
	position:absolute;
	width:80%;
	height:80%;
	display:block;
	z-index:3;
	margin-left:10vw;
	margin-top:10vh;

	.video{
		position:absolute;
		width:100%;
		height:100%;
		background-color:#000000CD;
		top:50%;
		left:50%;
		overflow:hidden;
		transform:translate(-50%,-50%);
		&.hidden{
			display:none;
		}
		.cropper{
			/*top:calc( -1500px + 50% );*/
			position:absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			video {
				width: 100%;
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
			}
			.video-wrap {
				position: absolute;
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				background-color:#000000;
			}
		}
	}
	.content{
		position:absolute;
		width:100%;
		height:100%;
		top:50%;
		left:50%;
		transform:translate(-50%,-50%);
		background-position:50% 50%;
		background-size:cover;
		background-repeat:no-repeat;
	}
}
.orientation-blocking{ display:none; }
@media #{$mobile-portrait}{
	.orientation-blocking{
		display:block;
		position:absolute;
		top:50vh; left:5%;
		width:90%; height:50vh;
		background-color:#000000CD;
		display:flex;
		align-items:center;
		justify-content:center;
		transform:translateY(-50vh);
		img.info{
			height:80%;
		}
	}
	.overlay{
		height:auto !important;
		.video{ display:none; }
		.content{
			display:none;
		}
	}
}
@media #{$mobile-landscape}{
	.overlay{
		height:80vh;
		.video{
			width:100%;
			.cropper{
				width:100%;
			}
			#youtube-player-element{
				width:100% !important;
			}
		}
		.content{
			width:100%;
			height:80vh;
		}
	}
}
</style>

<script>
import { section } from '../stores/navigation'

import { scale } from 'svelte/transition'

import scenario from '../stores/scenario'

import Options from './Options.svelte'
import Results from './Results.svelte'

let state = false
let lastnode = 'intro'

let showVideoOverlay = true
/*section.subscribe( s => {
  showVideoOverlay = s == 'tour'
} )*/

const tryAgain = () => {
	scenario.restart()
}

scenario.status.subscribe( n => {
	state = n
	if( ['video','results'].includes( state.type ) ){
		state.onLoad()
	}
	if( state.type == 'video' ){
	   var video = document.getElementById('html-video');
	   video.src = scenario.getVideoID(state.node);
	   video.play();
		// YouTube.loadVideo( scenario.getVideoID(state.node) )
		// YouTube.callOnFinish = state.onFinish
		video.onended = function() {
		    state.onFinish();
		};
		lastnode = state.node
	}
} )
</script>
